export { default } from './CookieBotBlock';
